import React, { useState } from 'react';

import { Container, OutsideClick } from './styles';

export default function Tooltip({ children, text, infoContent }) {
    const [visible, setVisible] = useState(false);
    return (
        <>
            {visible && <OutsideClick
                onClick={(e) => {
                    e.stopPropagation();
                    setVisible(false)
                }}
            />}
            <Container
                infoContent={infoContent}
                onClick={(e) => {
                    e.stopPropagation();
                    setVisible(!visible)
                }}
            >
                {children}
                {visible && <span>{text || ''}</span>}
            </Container>
        
        </>
    )
}